import { Box } from '@mui/material';
import { KsefState } from 'pages/invoices/invoices.types';
import { useTranslation } from 'react-i18next';

const statusConfig: Record<
  KsefState,
  { color: string; backgroundColor: string }
> = {
  SENDING: { color: '#1565C0', backgroundColor: '#DCEAFA' },
  ACCEPTED: { color: '#15803D', backgroundColor: '#DCFCE7' },
  REJECTED: { color: '#C0322F', backgroundColor: '#FDECEA' },
  NEEDS_REVIEW: { color: '#A2620F', backgroundColor: '#FDF3E2' },
};

export const KsefStatusChip = ({ state }: { state: KsefState | null }) => {
  const { t } = useTranslation('invoice');

  if (!state || !statusConfig[state]) return null;

  return (
    <Box
      component='span'
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 12px',
        borderRadius: '999px',
        fontSize: '13px',
        fontWeight: 500,
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        ...statusConfig[state],
      }}
    >
      {t(`ksefState.${state}`)}
    </Box>
  );
};
